import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb46986"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-modal-header" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "info-modal-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Made in Profectus, by thepaperpilot with inspiration from Acameada and Jacorb ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons info-modal-discord" }, "discord", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://discord.gg/WzejVAx",
    class: "info-modal-discord-link"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "material-icons info-modal-discord" }, "discord"),
    /*#__PURE__*/_createTextVNode(" The Paper Pilot Community ")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://discord.gg/F3xveHV",
    class: "info-modal-discord-link"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "material-icons info-modal-discord" }, "discord"),
    /*#__PURE__*/_createTextVNode(" The Modding Tree ")
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import Modal from "components/Modal.vue";
import type Changelog from "data/Changelog.vue";
import projInfo from "data/projInfo.json";
import { jsx } from "features/feature";
import player from "game/player";
import { infoComponents } from "game/settings";
import { formatTime } from "util/bignum";
import { coerceComponent, render } from "util/vue";
import { computed, ref, toRefs, unref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    changelog: null
  },
  setup(__props: any, { expose }) {

const _props = __props as { changelog: typeof Changelog | null }

const { title, logo, author, discordName, discordLink, versionNumber, versionTitle } = projInfo;


const props = toRefs(_props);

const isOpen = ref(false);

const timePlayed = computed(() => formatTime(player.timePlayed));

const infoComponent = computed(() => {
    return coerceComponent(jsx(() => <>{infoComponents.map(render)}</>));
});

expose({
    open() {
        isOpen.value = true;
    }
});

function openChangelog() {
    unref(props.changelog)?.open();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(logo))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "info-modal-logo",
              src: _unref(logo),
              alt: _unref(title)
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", null, _toDisplayString(_unref(title)), 1),
          _createElementVNode("h4", null, [
            _createTextVNode(" v" + _toDisplayString(_unref(versionNumber)), 1),
            (_unref(versionTitle))
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, ": " + _toDisplayString(_unref(versionTitle)), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    body: _withCtx(({ shown }) => [
      shown
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(author))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "By " + _toDisplayString(_unref(author)), 1))
              : _createCommentVNode("", true),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", {
              class: "link",
              onClick: openChangelog
            }, "Changelog"),
            _hoisted_9,
            _createElementVNode("div", null, [
              (_unref(discordLink) !== 'https://discord.gg/WzejVAx')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _unref(discordLink),
                    class: "info-modal-discord-link"
                  }, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_unref(discordName)), 1)
                  ], 8, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", null, "Time Played: " + _toDisplayString(_unref(timePlayed)), 1),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(infoComponent))))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})